import React, { FC } from 'react';
import AdSlot from 'components/ads/ad-slot';
import AdSlotPlaceholderGAM from 'components/ads/ad-slot-placeholder-gam';

import './ad-slot-below-filters.scss';

interface AdSlotBelowFiltersProps {
    name: string;
}

const AdSlotBelowFilters: FC<AdSlotBelowFiltersProps> = ({ name }) => (
    <AdSlotPlaceholderGAM
        className="ad-slot-below-filters"
        isHideAdText={true}
    >
        <AdSlot
            className="creation-below-filters"
            name={name}
        />
    </AdSlotPlaceholderGAM>
);

export default AdSlotBelowFilters;
